import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { cn } from "@/lib/utils";

// Multi-select commodity picker (searchable checklist). value/onChange work on an array of values.
export function MultiCombobox({ options, value = [], onChange, placeholder = "Select…", testid }) {
  const [open, setOpen] = useState(false);
  const toggle = (val) => {
    const next = value.includes(val) ? value.filter((v) => v !== val) : [...value, val];
    onChange(next);
  };
  const triggerLabel = value.length === 0
    ? placeholder
    : value.length === 1
      ? (options.find((o) => (o.value ?? o) === value[0])?.label ?? value[0])
      : `${value.length} commodities`;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="w-full h-10 px-3 flex items-center justify-between rounded-md border border-border bg-card text-sm text-foreground hover:border-primary/60 focus:outline-none focus:ring-2 focus:ring-orange-400"
        >
          <span className={cn("truncate", value.length === 0 && "text-muted-foreground")}>{triggerLabel}</span>
          <ChevronsUpDown size={15} className="text-muted-foreground shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] z-[1200]" align="start">
        <Command>
          <CommandInput placeholder="Search commodities…" className="text-sm" />
          <CommandList>
            <CommandEmpty>No match found.</CommandEmpty>
            <CommandGroup>
              {options.map((o) => {
                const val = o.value ?? o;
                const lab = o.label ?? o;
                const checked = value.includes(val);
                return (
                  <CommandItem key={val} value={lab} onSelect={() => toggle(val)}
                    data-testid={testid ? `${testid}-opt-${val}` : undefined}>
                    <span className={cn("mr-2 grid h-4 w-4 place-items-center rounded border", checked ? "bg-primary border-primary text-primary-foreground" : "border-border")}>
                      <Check size={12} className={cn(checked ? "opacity-100" : "opacity-0")} />
                    </span>
                    {lab}
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
